import httpService from '../../redux/apis/httpService';
import {
	setSessionExpired,
	updateAccessToken
} from '../../redux/features/auth-slice';

const interceptor = async (store: any) => {
	httpService.interceptors.request.use(
		(config: any) => {
			const auth = store.getState().auth;
			const deviceToken = auth.deviceToken;
			const accessToken = auth.token.accessToken;
			const refreshToken = auth.token.refreshToken;
			const currentUser = auth.currentRole;
			const devicetype = 'WEB';
			// Adding device token header
			if (config.url !== 'common/get-countries') {
				config.headers.common['devicetype'] = devicetype;
				if (deviceToken) {
					config.headers.common['devicetoken'] = deviceToken;
				}

				// Adding authorization header
				if (
					accessToken &&
					config.url !== 'auth/sign-in' &&
					config.url !== 'auth/check-rest-password-link'
				) {
					config.headers.common['Authorization'] = accessToken;
				}

				// Adding refresh token header
				if (
					refreshToken &&
					config.url !== 'auth/sign-in' &&
					config.url !== 'auth/check-rest-password-link'
				) {
					config.headers.common['refreshToken'] = refreshToken;
				}
				config.headers.common['cache-control'] = 'no-cache';
				config.headers.common['Expires'] = '0';
				if (config.url !== 'auth/user-role-accessed') {
					if (currentUser?._id) {
						config.headers.common['userRoleId'] = currentUser?._id;
					}
				}
			}
			return config;
		},
		(error) => Promise.reject(error)
	);

	httpService.interceptors.response.use(
		(next) => {
			if (next.headers['refreshed-access-token']) {
				store.dispatch(
					updateAccessToken(next.headers['refreshed-access-token'])
				);
			}
			return Promise.resolve(next);
		},
		(error) => {
			if (
				error?.response?.status === 401 &&
				error?.response?.config?.url !== 'auth/sign-in'
			) {
				const elements: any =
					document.getElementsByClassName('modal-backdrop');
				if (elements.length > 0) {
					elements[0].parentNode.removeChild(elements[0]);
				}
				const { isLoggedIn } = store.getState().auth;
				if (isLoggedIn) {
					store.dispatch(setSessionExpired());
				}
			}
			return Promise.reject(error);
		}
		// You can handle error here and trigger warning message without get in the code inside
	);
};
export default {
	interceptor
};
